{
  "id": "ripes",
  "name": "Ripes",
  "kind": "simulator",
  "spotlight": true,
  "seoTitle": "Ripes: visual RISC-V simulator and debugger",
  "seoDescription": "Ripes is a graphical RISC-V simulator and debugger. Inspect registers, memory, and pipeline stages while stepping through RISC-V assembly.",
  "url": "https://github.com/mortbopet/Ripes",
  "homepage": "https://ripes.dk/",
  "origin": "Morten Borup Petersen",
  "authors": [
    "Morten Borup Petersen"
  ],
  "started": 2017,
  "language": "C++, Qt",
  "license": "MIT",
  "isa": "RV32IMC, RV64IMC",
  "archived": false,
  "officialInstall": [
    {
      "kind": "releases",
      "requirements": [],
      "link": "https://github.com/mortbopet/Ripes/releases"
    },
    {
      "kind": "browser",
      "requirements": [],
      "link": "https://ripes.dk/"
    },
    {
      "kind": "source",
      "requirements": [
        "Qt >= 6.5.0 + Qt Charts",
        "CMake",
        "libegl1-mesa-dev (Linux)"
      ],
      "commands": [
        "git clone --recursive https://github.com/mortbopet/Ripes.git",
        "cd Ripes/",
        "cmake .",
        "make"
      ]
    }
  ],
  "capabilities": {
    "browser": true,
    "assembler": true,
    "stepBack": true,
    "registers": true,
    "memory": true,
    "callStack": false,
    "ecalls": true,
    "gpio": true,
    "breakpoints": true,
    "pipeline": true,
    "caches": true,
    "rv64": true
  },
  "sources": [
    {
      "label": "Ripes README",
      "url": "https://github.com/mortbopet/Ripes"
    },
    {
      "label": "Ripes: A Visual Computer Architecture Simulator, WCAE 2021",
      "url": "https://ieeexplore.ieee.org/document/9707149"
    }
  ],
  "blocks": [
    {
      "k": "h",
      "text": "Overview"
    },
    {
      "k": "p",
      "text": "Ripes is a graphical RISC-V simulator. A simulator is a program that imitates a processor. Ripes draws the processor's datapath, the diagram of wires, registers and units that data travels through, and highlights it as instructions move along."
    },
    {
      "k": "p",
      "text": "Ripes includes several processor models. The simplest finishes an instruction before starting the next. The pipelined models split execution into stages, such as fetching an instruction from memory, decoding it and executing it, and keep several instructions in progress at once, one per stage. The pipeline view shows hazards, the cases where an instruction needs a result that an earlier instruction has not produced yet, and how the processor waits or forwards data to resolve them."
    },
    {
      "k": "p",
      "text": "Ripes also simulates caches, small fast memories that keep recently used data close to the processor, and devices such as LEDs and switches that a program controls by reading and writing memory addresses."
    },
    {
      "k": "h",
      "text": "History"
    },
    {
      "k": "p",
      "text": "Morten Borup Petersen started Ripes in 2017 and still maintains it. The project was presented at the 2021 Workshop on Computer Architecture Education in the paper \"Ripes: A Visual Computer Architecture Simulator\"."
    },
    {
      "k": "p",
      "text": "Ripes is written in C++ with the Qt framework and released under the MIT license. Builds exist for Linux, Windows and macOS, and a WebAssembly build runs the same program inside a browser at ripes.dk."
    },
    {
      "k": "h",
      "text": "Where it is used"
    },
    {
      "k": "p",
      "text": "Ripes suits computer architecture courses, where students study how a processor executes code. With a RISC-V compiler installed, it also compiles C programs, so a student can compare a line of C with the machine code the compiler produces for it."
    }
  ]
}
